import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class ShareTaskStepService extends StepBaseService {
  // @ts-ignore
  getShareTaskStepKey = () => {
    return StepBusinessType.shareTask;
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}

export default new ShareTaskStepService();
